// Las tres pestañas de "Servicios de consultoría" del inicio, con el texto del diseño.
export const CONSULTORIA = {
  comercial: {
    pestana: 'Consultoría comercial',
    menu: 'Comercial',
    subtitle: 'Nueva propuesta de posicionamiento',
    title: 'Polz Asociados transforma terrenos en oportunidades de inversión inmobiliaria.',
    description: 'Analizamos el territorio, evaluamos su potencial, desarrollamos escenarios de inversión y acompañamos el proyecto hasta su comercialización.',
    detail: 'Optimizamos el rendimiento económico y la viabilidad de mercado de su inversión mediante inteligencia inmobiliaria y estructuración financiera avanzada.',
    servicesTitle: 'Servicios comerciales',
    mainServices: ['Diagnóstico Inmobiliario', 'Geointeligencia Territorial', 'Prefactibilidad de Inversión', 'Due Diligence Inmobiliario', 'Desarrollo y Comercialización'],
    items: [
      {
        title: 'Diagnóstico de oportunidad',
        bullets: [
          'Potencial inmobiliario del predio.',
          'Ubicación, conectividad e infraestructura.',
          'Normativa y restricciones.',
          'Análisis territorial y de mercado.',
          'Identificación de riesgos.',
        ],
      },
      {
        title: 'Geointeligencia territorial',
        bullets: [
          'Cartografía y análisis GIS.',
          'Topografía, hidrología y accesibilidad.',
          'Caminos, electricidad, servicios y equipamiento.',
          'Predios, proyectos y competencia.',
          'Mapas digitales y archivos KMZ/KML.',
        ],
      },
      {
        title: 'Prefactibilidad inmobiliaria',
        intro: 'Evaluación de distintos escenarios:',
        bullets: [
          'Venta del terreno.',
          'Subdivisión.',
          'Desarrollo inmobiliario.',
          'Turismo o proyectos rurales.',
          'Uso mixto.',
          'Asociación con inversionistas.',
        ],
        outro: 'Incluyendo una estimación preliminar de inversión, ingresos, costos, rentabilidad y plazos.',
      },
      {
        title: 'Due Diligence Integral',
        bullets: [
          'Legal: títulos, gravámenes, servidumbres y derechos.',
          'Territorial: normativa y restricciones.',
          'Técnico: agua, electricidad, caminos, suelo y topografía.',
          'Comercial: precios, demanda y competencia.',
        ],
      },
      {
        title: 'Desarrollo y comercialización',
        intro: 'Polz acompaña el proceso desde:',
        flow: ['Terreno', 'Diagnóstico', 'Prefactibilidad', 'Desarrollo', 'Comercialización', 'Venta'],
      },
    ],
  },
  inmobiliaria: {
    pestana: 'Consultoría inmobiliaria',
    menu: 'Inmobiliaria',
    subtitle: 'Consultoría inmobiliaria',
    title: 'Gestión técnica, legal y urbanística.',
    description: 'Brindamos soporte integral en la gestión técnica, legal y urbanística para asegurar que cada desarrollo cumpla con los más altos estándares normativos y operativos.',
    detail: '',
    servicesTitle: 'Servicios clave',
    mainServices: [],
    items: [
      { title: 'Due Diligence y Estudio de Títulos', description: 'Auditoría exhaustiva de dominios, gravámenes, hipotecas, servidumbres y prohibiciones en los Conservadores de Bienes Raíces para garantizar transacciones libres de contingencias.' },
      { title: 'Saneamiento Legal y Regularizaciones', description: 'Regularización de inmuebles, saneamiento de títulos imperfectos, constitución de servidumbres y trámites ante el Conservador y Notarías.' },
      { title: 'Subdivisiones, Fusiones y Loteos', description: 'Elaboración de proyectos de subdivisión predial, loteos urbanos y rurales con tramitación y aprobación ante el SAG, Minvu y Municipalidades.' },
      { title: 'Gestión Normativa y Permisología (DOM)', description: 'Gestión de anteproyectos, permisos de edificación, modificaciones de proyectos y recepciones definitivas ante las Direcciones de Obras Municipales (DOM).' },
      { title: 'Dirección Técnica y Supervisión de Obras', description: 'Coordinación técnica de especialidades, control presupuestario, cubicaciones y supervisión del avance físico de obras de urbanización y viales.' },
    ],
  },
  ambiental: {
    pestana: 'Consultoría medioambiental',
    menu: 'Medioambiental',
    subtitle: 'Consultoría medioambiental',
    title: 'Viabilidad ambiental y social para un desarrollo responsable.',
    description: 'Aseguramos la viabilidad ambiental y social de los proyectos inmobiliarios, anticipando contingencias regulatorias y promoviendo un desarrollo sustentable y responsable.',
    detail: '',
    servicesTitle: 'Servicios ambientales',
    mainServices: [],
    items: [
      { title: 'Permisos ambientales', description: 'Autorizaciones oficiales que certifican que un proyecto cumple la normativa ambiental vigente, evaluando sus impactos y estableciendo condiciones para su ejecución responsable.' },
      { title: 'Estudios de sostenibilidad', description: 'Análisis integrales que determinan la capacidad de un proyecto u operación para mantenerse en el tiempo sin comprometer recursos naturales, bienestar social ni viabilidad económica.' },
      { title: 'Estudios de riesgos ambientales', description: 'Evaluaciones que identifican, cuantifican y caracterizan amenazas ambientales que podrían afectar a un proyecto, comunidad o ecosistema, proponiendo medidas de prevención y mitigación.' },
      { title: 'Estudios de conectividad', description: 'Diagnósticos que analizan la continuidad ecológica y funcional del territorio, evaluando corredores biológicos, flujos de fauna y conectividad entre ecosistemas para evitar fragmentación.' },
      { title: 'Estudios de peligro de remoción de masas', description: 'Investigaciones geotécnicas que determinan la susceptibilidad del terreno a deslizamientos, derrumbes o caídas de material, definiendo zonas de riesgo y medidas de seguridad.' },
      { title: 'Estudios de viabilidad hídrica', description: 'Evaluaciones que determinan la disponibilidad, calidad y sustentabilidad del recurso hídrico necesario para un proyecto, considerando oferta, demanda y riesgos de escasez.' },
      { title: 'Estudios de viabilidad energética', description: 'Análisis que verifican la factibilidad de abastecer un proyecto con energía suficiente, segura y sostenible, evaluando fuentes, infraestructura y eficiencia energética.' },
      { title: 'Estudios de viabilidad e independencia alimentaria', description: 'Estudios que determinan la capacidad de un territorio o comunidad para producir y abastecer sus propios alimentos de manera sostenible, reduciendo dependencia externa.' },
      { title: 'Planes de Manejo Forestal', description: 'Instrumentos técnicos que regulan el uso, conservación y aprovechamiento de recursos forestales, definiendo prácticas de manejo sostenible, protección de biodiversidad y restauración.' },
    ],
  },
};
